module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.b64250ae.jpg";